import { ShieldCheck, UserPlus, User } from "lucide-react";

export const roles = [
  {
    label: "Admin",
    value: "org:admin",
    icon: ShieldCheck,
    title: "Admin",
    description: `Admin members can create organizations, create Easy GPTs, access Easy GPT dashboards, invite managers, and invite Easy GPT team members based on plan limits.
This role is designed for person responsible for operations of an organization.`,
  },
  {
    label: "Manager",
    value: "org:member",
    icon: UserPlus,
    title: "Manager",
    description: `Managers can create Easy GPTs based on plan limits, access Easy GPT dashboard and invite team members to access Easy GPTS.
This role is designed for account managers, project managers, who manage Easy GPTs for their organization.`,
  },
  {
    label: "Team member",
    title: "Team member",
    value: "org:external_collaborator",
    icon: User,
    description: `Team members can access Easy GPT dashboard including
Conversation, Contacts, Embed Code, Appearance, Knowledge, Conversation Settings, Locations, Integrations, Notifications and invite other team member based on plan limits.
This role is designed for sales, support and customer service team members who are responsible for inquires from your website.`,
  },
];
